import type { DefaultObject } from '@moniebook-web/types';
import { getBaseService } from '@moniebook-web/utils';
import { type FirebaseOptions } from 'firebase/app';

const firebaseDefaults = {
    FIREBASE_API_KEY:
        process.env.FIREBASE_API_KEY ??
        'AIzaSyB6i-rf342grh_ECzMwzYu_CA7xNQa-eNk',
    FIREBASE_AUTH_DOMAIN:
        process.env.FIREBASE_AUTH_DOMAIN ?? 'moniebook-319eb.firebaseapp.com',
    FIREBASE_PROJECT_ID: process.env.FIREBASE_PROJECT_ID ?? 'moniebook-319eb',
    FIREBASE_STORAGE_BUCKET:
        process.env.FIREBASE_STORAGE_BUCKET ??
        'moniebook-319eb.firebasestorage.app',
    FIREBASE_MESSAGING_SENDER_ID:
        process.env.FIREBASE_MESSAGING_SENDER_ID ?? '283279096494',
    FIREBASE_APP_ID:
        process.env.FIREBASE_APP_ID ??
        '1:283279096494:web:7efef8cb6578c3b7724b3f',
    FIREBASE_MEASUREMENT_ID:
        process.env.FIREBASE_MEASUREMENT_ID ?? 'G-X7GE4JQRRZ',
};

const CHANGE_TRACKER_KEY =
    process.env.CHANGE_TRACKER_KEY ?? 'change_tracker_dev';
const REGISTER_EVENT_TRACKER_KEY =
    process.env.REGISTER_EVENT_TRACKER_KEY ?? 'register_event_tracker_dev';
const STOCK_EVENT_TRACKER_KEY =
    process.env.REGISTER_EVENT_TRACKER_KEY ?? 'stock_update_tracker_dev';
const TERMINAL_PAYMENT_TRACKER_KEY =
    process.env.TERMINAL_PAYMENT_TRACKER_KEY ?? 'terminal_payment_tracker_dev';
const RENDER_BUFFER_ID =
    process.env.RENDER_BUFFER_ID ?? 'moniebook-register-v1';

const serviceUrl: DefaultObject = {
    CHANGE_TRACKER_KEY,
    REGISTER_EVENT_TRACKER_KEY,
    TERMINAL_PAYMENT_TRACKER_KEY,
    STOCK_EVENT_TRACKER_KEY,
    RENDER_BUFFER_ID,
};

const getService = getBaseService(serviceUrl);

const getFirebaseConfig = getBaseService(firebaseDefaults);

const firebaseConfig: FirebaseOptions = {
    apiKey: getFirebaseConfig('FIREBASE_API_KEY'),
    authDomain: getFirebaseConfig('FIREBASE_AUTH_DOMAIN'),
    projectId: getFirebaseConfig('FIREBASE_PROJECT_ID'),
    storageBucket: getFirebaseConfig('FIREBASE_STORAGE_BUCKET'),
    messagingSenderId: getFirebaseConfig('FIREBASE_MESSAGING_SENDER_ID'),
    appId: getFirebaseConfig('FIREBASE_APP_ID'),
    measurementId: getFirebaseConfig('FIREBASE_MEASUREMENT_ID'),
};

export const sharedConfig = {
    FIREBASE: firebaseConfig,
    CHANGE_TRACKER_KEY: getService('CHANGE_TRACKER_KEY'),
    REGISTER_EVENT_TRACKER_KEY: getService('REGISTER_EVENT_TRACKER_KEY'),
    STOCK_EVENT_TRACKER_KEY: getService('STOCK_EVENT_TRACKER_KEY'),
    TERMINAL_PAYMENT_TRACKER_KEY: getService('TERMINAL_PAYMENT_TRACKER_KEY'),
    RENDER_BUFFER_ID: getService('RENDER_BUFFER_ID'),
};
